<template>
  <div>
    <div
      id="header-position"
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <div class="d-flex">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/administrator/position')"
        >
        <div class="auto__label-head"> {{ data_position.name }} </div>
        <b-col
          v-if="mode=='update'">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10"/>
        </b-col>
      </div>
      <div
        v-if="mode=='update'"
        class="sub-title">{{ assign_employee }}</div>
    </div>

    <div class="studio-page-content">
      <b-row align-h="start">
        <b-col cols="4">
          <b-form-group>
            <label>ID</label>
            <j-input
              v-model="data_position.id"
              :max-length="255"
              :disabled="true"
              placeholder="ID"/>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group :class="{'error-input' : $v.data_position.code.$error}">
            <label>Code</label>
            <j-input
              v-model="data_position.code"
              :max-length="255"
              placeholder="Code"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="start">
        <b-col cols="4">
          <b-form-group :class="{'error-input' : $v.data_position.name.$error}">
            <label>Position Name</label>
            <j-input
              v-model="$v.data_position.name.$model"
              :max-length="255"
              placeholder="Position Name"/>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            :class="{'error-input' : $v.data_position.parent.$error}">
            <label>Parent Position</label>
            <j-single-select
              v-if="defaultParentLoaded"
              v-model="$v.data_position.parent.$model"
              :is-async="true"
              :load-options="loadOptionsParent"
              :default-options="defaultParent"
              value-format="object"
              placeholder="Select Parent"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="start">
        <b-col cols="4">
          <b-form-group
            :class="{'error-input' : $v.data_position.layer.$error}">
            <label>Layer</label>
            <j-single-select
              v-if="defaultLayerLoaded"
              v-model="$v.data_position.layer.$model"
              :is-async="true"
              :load-options="loadOptionsLayer"
              :default-options="defaultLayer"
              value-format="object"
              placeholder="Select Layer"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            :class="{'error-input' : $v.data_position.divisions.$error}">
            <label>Unit</label>
            <j-single-select
              v-if="defaultUnitLoaded"
              v-model="$v.data_position.divisions.$model"
              :is-async="true"
              :load-options="loadOptionsDivisions"
              :default-options="defaultUnit"
              value-format="object"
              placeholder="Select Unit"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            v-if="mode== 'update'"
            class="btn m__r--5 blue"
            @click="saveUpdatePosition">
            Update
          </b-button>
          <b-button
            v-if="mode== 'create'"
            class="btn m__r--5 blue"
            @click="saveCreatePosition">
            Create
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-popover
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      container="header-position"
      placement="bottom">
      <div
        class="position-config-opt"
        @click="onClickDelete">
        Delete
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  validations() {
    return {
      data_position: {
        id: { },
        name: { required },
        code: { required },
        divisions: { },
        parent: { },
        layer: { },
        assign_employee: { },
        temp_employee: { required: requiredIf(() => this.data_position.start_date !== null) },
        start_date: { required: requiredIf(() => this.data_position.temp_employee !== null) },
        end_date: { },
        location_id: {},
        mapping_timesheet_rule: {},
      },
    };
  },
  data() {
    return {
      defaultUnit: [],
      defaultParent: [],
      defaultLayer: [],
      defaultLayerLoaded: false,
      defaultParentLoaded: false,
      defaultUnitLoaded: false,

      configPopoverShow: false,
      mode: 'create',
      data_position: {
        id: '',
        name: '',
        code: '',
        divisions: null,
        parent: null,
        layer: null,
        assign_employee: null,
        temp_employee: null,
        start_date: null,
        end_date: null,
        location_id: null,
        mapping_timesheet_rule: null,
      },
    };
  },
  computed: {
    ...mapState('jStorePosition', ['position_detail', 'divisions_detail', 'layer_detail', 'employee_detail']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),

    generateData() {
      const data = {
        id: this.data_position.id,
        name: this.data_position.name,
        code: this.data_position.code,
        user_company_id: this.data_position.assign_employee ?
          Number(this.data_position.assign_employee.id) : null,
        location_id: {
          id: this.data_position.location_id ? Number(this.data_position.location_id.id) : '',
        },
      };

      if (this.data_position.description) {
        data.description = '';
      }

      if (this.data_position.divisions) {
        data.divisions = this.data_position.divisions ?
          [this.data_position.divisions.id] : [];
      }

      if (this.data_position.layer) {
        data.position_layer = {
          id: this.data_position.layer.id,
        };
      }

      if (this.data_position.parent) {
        data.organigram_head_id = this.data_position.parent.id;
      }

      return data;
    },
    assign_employee() {
      return this.data_position.assign_employee ? this.data_position.assign_employee.email : 'Vacant';
    },
  },
  watch: {

    position_detail(val) {
      let newDivisions = null;
      let newLayer = null;
      let newParent = null;
      let newAssignEmployee = null;
      let newMappingRule = null;

      if (val.divisions && val.divisions.length) {
        newDivisions = { ...val.divisions[0], label: val.divisions[0].name };
      }

      if (val.position_layer) {
        newLayer = { ...val.position_layer, label: val.position_layer.name };
      }

      if (val.organigram_head_id) {
        newParent = { id: val.organigram_head_id, label: val.organigram_head_name };
      }

      if (val.user) {
        newAssignEmployee = {
          id: val.user.id,
          label: val.user.profile ?
            `${val.user.profile.first_name} ${val.user.profile.last_name}` :
            `${val.user.first_name} ${val.user.last_name}`,
          email: val.user.email,
        };
      }

      if (val.mapping_timesheet_rule) {
        newMappingRule = {
          id: val.mapping_timesheet_rule.id,
          label: val.mapping_timesheet_rule.name,
        };
      }

      this.data_position.location_id = val.location;
      this.data_position.id = val.id;
      this.data_position.name = val.name;
      this.data_position.code = val.code;
      this.data_position.divisions = newDivisions;
      this.data_position.parent = newParent;
      this.data_position.layer = newLayer;
      this.data_position.assign_employee = newAssignEmployee;
      this.data_position.mapping_timesheet_rule = newMappingRule;

      this.organigram_member_id = val.organigram_member_id;
    },

    divisions_detail(val) {
      this.data_position.divisions.push({
        id: val.id, label: val.name,
      });
    },

    layer_detail(val) {
      this.data_position.layer = {
        id: val.id, label: val.name,
      };
    },

    employee_detail(val) {
      this.data_position.assign_employee = {
        id: val.id, label: `${val.profile.first_name} ${val.profile.last_name}`, email: val.profile.email,
      };
    },
  },
  created() {
    this.getListDefaultDivision().then((data) => {
      this.defaultUnit = data;
      this.defaultUnitLoaded = true;
    });
    this.getListLayerDefault().then((data) => {
      this.defaultLayer = data;
      this.defaultLayerLoaded = true;
    });
    this.getListParentDefault().then((data) => {
      this.defaultParent = data;
      this.defaultParentLoaded = true;
    });
  },
  mounted() {
    if (window.location.href.includes('position/update')) {
      this.mode = 'update';
      const positionId = {
        id: Number(this.$route.params.id),
      };
      this.getDetailPosition(positionId);
    }
  },
  methods: {
    ...mapActions('jStorePosition', ['updatePosition', 'deletePosition', 'getDetailPosition', 'updateOrganigramTemp', 'deleteOrganigramTemp', 'getDetailOrganigramTemp', 'getListCompanyLocation', 'createPosition', 'getListDefaultDivision', 'getListLayerDefault', 'getListParentDefault']),
    loadOptionsParent({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query_type: 'position',
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStorePosition/getListParent', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    loadOptionsLayer({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
              query_type: 'name',
            },
          };
          this.$store.dispatch('jStorePosition/getListLayer', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    loadOptionsDivisions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStorePosition/getListDivisions', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    saveUpdatePosition() {
      this.$v.data_position.$touch();
      if (!this.$v.data_position.$error) {
        this.updatePosition(this.generateData);
      }
    },
    saveCreatePosition() {
      this.$v.data_position.$touch();
      if (!this.$v.data_position.$error) {
        this.createPosition(this.generateData);
      }
    },
    onClickDelete() {
      this.$swal({
        title: 'Confirm Delete',
        text: 'Are you sure want to delete this position?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.deletePosition({ id: Number(this.$route.params.id) });
        }
      });
    },
  },
};
</script>

<style scoped>
  .header-position{
      padding: 20px;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      background-color: #FFFFFF;
      border: 1px solid #F1F1F1;
      min-height: 126px;
  }
  .body-position{
      background-color: #FCFDFE;
      padding: 30px;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;
      border: 1px solid #F1F1F1;
  }
  .position-config-opt {
    padding: 5px;
    font-size: 14px;
    cursor: pointer;
    margin-left: -5px;
    margin-right: -5px;
  }

  .position-config-opt:hover {
    background-color: #f2f2f2;
  }
  .sub-title{
    margin-left: 30px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/position/jPositionForm.vue